import { createFileRoute } from '@tanstack/react-router'
import RelatoriosLeadsPage from '@/pages/relatorios/relatorios-leads-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/relatorios/leads',
)({
  component: function RelatoriosLeadsRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.RELATORIOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_REPORTS}>
          <RelatoriosLeadsPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
